export function getWeekDay(date) {
  date = new Date(date);
  let days = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

  return days[date.getDay()];
}

// let date = new Date(2014, 0, 3); // 3 января 2014 года
// alert( getWeekDay(date) ); // ПТ

export function removeParentheses(string) {
  return string?.replaceAll(/[()]/g, '')
}

export function isWeekEnd(date) {
  const nums = new Set([4, 5])
  let dow

  if (date) dow = date.getUTCDay()
  else dow = new Date().getUTCDay()

  return nums.has(dow)
}

export function extractHour(timeStr) {
  if (!timeStr) return undefined
  return Number(timeStr.split(':')[0])
}

export function extractMinute(timeStr) {
  if (!timeStr) return undefined
  return Number(timeStr.split(':')[1])
}

const getTypeCard = (indexCard, windowWidth) => { //NewJob page
  //есть три варианта последовательности карточек
  //1 'list' 'img' 'img' 'list' -- от 769px и выше
  //2 'img' 'img' 'list' 'list' -- от 376 до 768px
  //3 'img' 'list' 'img' 'list' -- от 376 px и ниже,
  // где list -- карточка со списком преимуществ работы, 
  // а img -- карточка с картинкой

  if (windowWidth > 769) { //0'list' 1'img' 2'img' 3'list'
    const layoutCardNumber = indexCard%4;

    if (layoutCardNumber === 0 || layoutCardNumber === 3) { 
      return 'list'
    }
    if (layoutCardNumber === 1 || layoutCardNumber === 2) {
      return 'img'
    }
  }

  // if (windowWidth < 769 && windowWidth >= 376) { //0'img' 1'img' 2'list' 3'list'
  if (windowWidth <= 769 && windowWidth > 600) { //0'img' 1'img' 2'list' 3'list'

    const layoutCardNumber = indexCard%4;

    if (layoutCardNumber === 2 || layoutCardNumber === 3) {
      return 'list'
    }
    if (layoutCardNumber === 0 || layoutCardNumber === 1) {
      return 'img'
    }
  }

  // if (windowWidth < 376) { //0'img' 1'list' 'img' 'list'
  if (windowWidth <= 600) { //0'img' 1'list' 'img' 'list'

    const layoutCardNumber = indexCard%2;

    if (layoutCardNumber === 1) {
      return 'list'
    }
    if (layoutCardNumber === 0) {
      return 'img'
    }
  }
}

export const getGeneralCardsInfo = (listArr, imgArr, windowWidth) => { //NewJob page
  let currentListItem = 0;
  let currentImgItem = 0;

  const generalArray = [];

  const lengthGeneral = listArr.length + imgArr.length;
  for (let i = 0; i < lengthGeneral; i++) { //i это generalIndex
    const typeCard = getTypeCard(i, windowWidth);

    if (typeCard === 'list') {
      generalArray.push(listArr[currentListItem]);
      currentListItem++;
    }
    if (typeCard === 'img' ) {
      generalArray.push(imgArr[currentImgItem]);
      currentImgItem++;
    }
  }
  return generalArray;
}

export const getDistance = (width, fieldName) => {
  switch (fieldName) {
    case 'last_name':
    case 'first_name': 
    case 'middle_name': //`calc(33% - distance)`
    return width > 2350 ? '13px' 
      : width > 2001 ? '8px'  
      : (width > 1441) ? '4px' 
      : (width > 1025) ? '4px' : '4px'

    case 'phone':
    case 'position':
      return width > 2001 ? '13px' 
        : (width > 1441) ? '6px' 
        : (width > 1025) ? '6px' : '6px'

    case 'city':
      return width > 2001 ? '13px' 
        : (width > 1441) ? '8px' 
        : (width > 1025) ? '8px' : '8px'

      default:
        return `0px`;
  }
}

export const getMarginInlineStart = (width, fieldName) => {
  switch (fieldName) {
    case 'first_name':
    case 'middle_name':
      return width > 2350 ? 25.5 
        : width > 2001 ? 17 
        : (width > 1441) ? 8 
        : (width > 1025) ? 8 : 8

    default:
      return 0
  }
}